<template>
    <Card :title="$t('labels.transfer')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6">
                    <FormGroup :label="$t('labels.warehouse_from')">
                        <AppAutoComplete
                            url="/management/warehouses"
                            :model-value="transfer?.warehouse_from?.uuid"
                            :selected-value="transfer?.warehouse_from?.name"
                            :query-params="{
                                ignore_uuids: [transfer?.warehouse_to?.uuid]
                            }"
                            @update:model-value="transfer.warehouse_from = $event"
                            :disabled="transfer?.completed_at !== null"
                            can-be-empty
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-6">
                    <FormGroup :label="$t('labels.warehouse_to')">
                        <AppAutoComplete
                            url="/management/warehouses"
                            :model-value="transfer?.warehouse_to?.uuid"
                            :selected-value="transfer?.warehouse_to?.name"
                            :query-params="{
                                ignore_uuids: [transfer?.warehouse_from?.uuid]
                            }"
                            @update:model-value="transfer.warehouse_to = $event"
                            :disabled="transfer?.completed_at !== null"
                            can-be-empty
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-between align-items-center">
            <div class="list-icons text-muted">
                <span class="list-icons-item">
                    <i class="icon-plus3 mr-2"></i> {{ DateFormatter.formatDateTime(transfer?.created_at) }}
                </span>

                <span class="list-icons-item ml-3">
                    <i class="icon-pencil mr-2"></i> {{ DateFormatter.formatDateTime(transfer?.updated_at) }}
                </span>

                <span class="list-icons-item ml-3" v-if="transfer?.completed_at">
                    <i class="icon-checkmark mr-2"></i> {{ DateFormatter.formatDateTime(transfer?.completed_at) }}
                </span>
            </div>
            <div class="d-flex justify-content-end flex-wrap" style="gap: .5rem;">
                <AppButton color="teal" :disabled="$refs.TransferProductsTable?.totalProducts === 0 || buttonsDisabled" @click="completeTransfer">
                    <i class="icon-checkmark3 mr-2"></i>
                    {{ $t('buttons.complete') }}
                </AppButton>
                <AppButton color="light" :disabled="buttonsDisabled" @click="deleteTransfer">
                    <i class="icon-trash mr-2"></i>
                    {{ $t('buttons.delete') }}
                </AppButton>
                <AppButton color="indigo" :disabled="buttonsDisabled" @click="editTransfer">
                    <i class="icon-floppy-disk mr-2"></i>
                    {{ $t('buttons.edit') }}
                </AppButton>
            </div>
        </div>
    </Card>
    <ProductsCard ref="TransferProductsTable" :transfer="transfer" />
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import ProductsCard from './cards/ProductsCard.vue';
import FormGroup from '../../../../components/new/form/group/FormGroup.vue';
import AppAutoComplete from '../../../../components/new/form/autocomplete/AppAutoComplete.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';

import { httpClient } from '../../../../services/HttpClient';
import MessageNotificator from '../../../../services/MessageNotificator';
import DateFormatter from '../../../../services/DateFormatter';

export default {
    name: 'TransferEditPage',
    components: {
        Card, FormGroup, AppAutoComplete, AppButton, ProductsCard
    },
    data() {
        return {
            DateFormatter,
            transfer: null
        }
    },
    methods: {
        async fetchTransfer() {
            await httpClient.get(`/projects/${this.$route.params.projectUuid}/wms/transfers/${this.$route.params.transferUuid}`).then(response => {
                this.transfer = response.data.data;
            });
        },
        async editTransfer() {
            await httpClient.put(`/projects/${this.$route.params.projectUuid}/wms/transfers/${this.$route.params.transferUuid}`, {
                warehouse_from_uuid: this.transfer?.warehouse_from?.uuid,
                warehouse_to_uuid: this.transfer?.warehouse_to?.uuid
            }).then(() => {
                new MessageNotificator().success(this.$t('alerts.success'));
            })
        },
        deleteTransfer() {
            new MessageNotificator().confirm(`${this.$t('alerts.confirm_delete', {
                value: this.$t('labels.transfer')
            })}`, async () => {
                await httpClient.delete( `/projects/${this.$route.params.projectUuid}/wms/transfers/${this.$route.params.transferUuid}`).then(() => {
                    this.$router.replace({ name: 'TransferIndexPage' });
                })
            })
        },
        async completeTransfer() {
            new MessageNotificator().confirm(this.$t('alerts.confirm_complete', {
                value: this.$t('labels.transfer')
            }), async () => {
                await httpClient.post(`/projects/${this.$route.params.projectUuid}/wms/transfers/${this.$route.params.transferUuid}/complete`)
                    .then(() => {
                        this.fetchTransfer();
                        new MessageNotificator().success(this.$t('alerts.success'));
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 409 && error.response.data.message === 'Transfer products has enough stock.') {
                            new MessageNotificator().successConfirm(
                                this.$t('alerts.transfer_products_not_enough_balance'),
                                () => {
                                    this.$refs.TransferProductsTable.filterNegativeDiff();
                                }
                            );
                        }
                    });
            })
        }
    },
    computed: {
        buttonsDisabled() {
            if (this.transfer?.completed_at !== null) {
                return true;
            }

            if (!this.transfer?.warehouse_from || !this.transfer?.warehouse_to) {
                return true;
            }

            return false;
        }
    },
    mounted() {
        this.fetchTransfer();
    }
}
</script>